export const bookings = state => state.getIn(['bookings', 'entities']);
export const bookingById = (state, id) => bookings(state).get(String(id));
export const bookingsByIds = (state, ids) => ids.map(id => bookingById(state, id));
